import { EditableInfoContainer } from '@dealstack/frontend/shared/components/EditableInfoContainer/EditableInfoContainer.tsx';
import { UserRowWithActions } from '@dealstack/frontend/shared/components/UserRowWithActions/UserRowWithActions.tsx';
import { generatePath } from 'react-router-dom';
import {
	DEAL_ROUTES,
	PEOPLE_ROUTES,
	ROUTES,
} from '@dealstack/frontend/app/pages/Routing/routes.ts';
import React from 'react';
import { PersonRelationType, RelatedPersonRes } from '@dealstack/shared/lib/generated';
import { TEST_ELEMENT_IDS, makeComplexDataTestId } from '@dealstack/shared/tests/testElementIds';

interface Props {
	title: string;
	dealId: string;
	people: RelatedPersonRes[];
	relationType: PersonRelationType;
	onUserEditClick?: (relatedPerson: RelatedPersonRes, relationType: PersonRelationType) => void;
	onUserDeleteClick: (params: {
		relatedPerson: RelatedPersonRes;
		relationType: PersonRelationType;
	}) => void;
	onAddRelatedPeople?: (relationType: PersonRelationType) => void;
	hasEditPermission: boolean;
}

export const RelationSectionWithPeople = ({
	title,
	people,
	dealId,
	onUserEditClick,
	onUserDeleteClick,
	relationType,
	onAddRelatedPeople,
	hasEditPermission,
}: Props) => {
	return people.length ? (
		<EditableInfoContainer
			title={title}
			isEdit={false}
			hasEditorPermission={hasEditPermission}
			gridColumns={4}
			useGrid={true}
			childrenPadding="0.5rem"
			onAdd={onAddRelatedPeople ? () => onAddRelatedPeople(relationType) : undefined}
		>
			{people.map((person) => (
				<UserRowWithActions
					key={person.id}
					displayName={person.displayName ?? ''}
					subtitle={person.customRelationType}
					dataTestId={makeComplexDataTestId(
						TEST_ELEMENT_IDS.CAP_RELATED_PEOPLE_ROW,
						`${relationType}_${person.id}`
					)}
					editBtnDataTestId={makeComplexDataTestId(
						TEST_ELEMENT_IDS.CAP_RELATED_PEOPLE_ROW_EDIT_BUTTON,
						`${relationType}_${person.id}`
					)}
					deleteBtnDataTestId={makeComplexDataTestId(
						TEST_ELEMENT_IDS.CAP_RELATED_PEOPLE_ROW_DELETE_BUTTON,
						`${relationType}_${person.id}`
					)}
					onUserDeleteClick={() =>
						onUserDeleteClick({ relatedPerson: person, relationType })
					}
					onUserEditClick={
						onUserEditClick ? () => onUserEditClick(person, relationType) : undefined
					}
					userLink={generatePath(
						`${ROUTES.DEAL}${DEAL_ROUTES.PEOPLE}${PEOPLE_ROUTES.PERSON_DETAILS}`,
						{
							dealId: dealId ?? '',
							personId: person.id,
						}
					)}
					hasEditPermission={hasEditPermission}
				/>
			))}
		</EditableInfoContainer>
	) : null;
};
